import React, { useState, useEffect, useRef } from "react";
import { Mensaje } from "../mensajes";
import { Dimmer } from "../spinner";

import useTableFijo from "../useTableFijo";
import axios from "axios";
import { ActualizarTipopro } from "./modalActualizarTipopro";
import { formatMoneda, validaSoloNumero } from "../../util/varios";
import moment from "moment";
import CatalogoRequi from "../../catalogos/catalogoRequisicion";
import AgregarProducto from "./agregarProducto";
import { Toasts } from "../toasts";
import { Input, SearchInput, Textarea } from "../../ui/inputs/Input";
import {
  DangerButton,
  InfoButton,
  PrimaryButton,
  SuccessButton,
  WarningButton,
} from "../../ui/buttons/Button";

const headCells = [
  {
    id: "idtipoproducto",
    label: "CODIGO",
    width: "80px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "descripcion",
    label: "CANTIDAD",
    width: "440px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
  {
    id: "accion",
    label: "PRODUCTO",
    width: "180px",
    textAlign: "center",
    backgroundColor: "rgba(5, 81, 130, 1)",
    fontSize: "10px",
    color: "white",
  },
];

function TablaRequisicion(props) {
  const [titulo, setTitulo] = useState();
  const [msg, setMsg] = useState();
  // const [titulo1, setTitulo1] = useState();
  // const [msg1, setMsg1] = useState();
  const [activo, setActivo] = useState(true);
  const [activo2, setActivo2] = useState(true);
  const [idProducto, setIdProdcuto] = useState();
  const [mensaje, setMensaje] = useState({
    mostrar: false,
    titulo: "",
    texto: "",
    icono: "",
  });
  const [visibleBtn, setVisibleBtn] = useState("visible");
  const [botones, setBotones] = useState({
    incluir: false,
    consultar: false,
    modificar: false,
    eliminar: false,
    aceptar: true,
    cancelar: true,
    catalogo: true,
    catalogoBene: true,
  });
  const [mostrar, setMostrar] = useState(false);
  const [mostrar2, setMostrar2] = useState(false);
  // const [mostrar3, setMostrar3] = useState(false);
  // const [mostrar4, setMostrar4] = useState(false);
  const [mostrar5, setMostrar5] = useState(false);
  const [tipopro, setTipopro] = useState();
  const [puc, setPuc] = useState();
  const [itemSelect, setItemSelect] = useState(-1);
  const permiso = JSON.parse(localStorage.getItem("accrequisicion"));

  // const [cuentaCont, setCuentaCont] = useState();
  const [activate, setActivate] = useState(false);
  const [declaWeb] = useState(false);
  // const [datoscuentas, setDatoscuentas] = useState(false);
  const [cuenta] = useState(false);
  const [fechaSistema] = useState(
    JSON.parse(localStorage.getItem("fechasistema"))
  );
  const [idusuario] = useState(localStorage.getItem("idusuario"));
  const [ip] = useState(localStorage.getItem("ip"));
  const [idefiscal] = useState(JSON.parse(localStorage.getItem("idefiscal")));
  const [mac] = useState(localStorage.getItem("mac"));
  const [habilitado, setHabilitado] = useState(true);

  const [operacion, setOperacion] = useState(0);
  const [operacionPro, setOperacionPro] = useState(0);
  const [toast, setToast] = useState({
    mostrar: false,
    mensaje: "",
    titulo: "",
  });

  const txtId = useRef();
  const txtFecha = useRef();
  const txtConcepto = useRef();
  const txtObservacion = useRef();
  const btnCancela = useRef();
  const btnAcepta = useRef();

  const [records, setRecords] = useState([]);

  const [filterFn, setFilterFn] = useState({
    fn: (items) => {
      return items;
    },
  });

  let token = localStorage.getItem("jwtToken");
  let op = require("../../../src/modulos/datos");

  const { TblContainer, TblHead } = useTableFijo(records, headCells, filterFn);

  const blanquear = () => {
    setOperacion(0);
    setOperacionPro(0);
    setActivo2(true);
    setActivo(true);

    setVisibleBtn("visible");

    setBotones({
      incluir: false,
      consultar: false,
      modificar: false,
      eliminar: false,
      aceptar: true,
      cancelar: true,
      catalogo: true,
      catalogoBene: true,
    });

    setActivate(false);

    setHabilitado(true);
  };
  const cerrarToast = () => {
    setToast({
      ...toast,
      mostrar: false,
    });
  };

  const seleccionarFila = (index) => (event) => {
    event.preventDefault();
    setItemSelect(index);
    setIdProdcuto(records[index].idproducto);
    console.log(records[index].idproducto);
    setActivo2(false);
  };

  const seleccionarRegistros = () => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let orden = "idtipoproducto";

    let endpoint = `${op.conexion}/api/comun/seleccionaregistros?campos=${campos}&nomtab=${nomtab}&orden=${orden}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          setRecords(response.data);
          setActivate(false);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar(true);
        setActivate(false);
      });
  };

  const seleccionarRegistro = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "tipoproducto";
    let nomid = "idtipoproducto";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}`;
    setActivate(true);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idtipoproducto > 0) {
            setTipopro(response.data);
            seleccionarRegistroPucxProduct(response.data.idtipoproducto);
          }
        } else {
          setActivate(false);
        }
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroPucxProduct = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "pucxtipoproducto";
    let nomid = "idtipoproducto";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}`;

    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          if (response.data.length > 0) {
            if (parseInt(response.data[0].idpuc) > 0) {
              seleccionarRegistroPuc(response.data[0].idpuc);
              seleccionarRegistroCtaxProduct(idtipoproducto);
              console.log(response.data[0].idpuc);
            }
          } else {
            setTitulo("Notificacion");
            setMsg("El Clasificador Presupuestario no existe");
            setMostrar(true);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroCtaxProduct = (idtipoproducto) => {
    let campos = "*";
    let nomtab = "cuentacontablextipoproducto";
    let nomid = "idtipoproducto";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&id=${idtipoproducto}&nomtab=${nomtab}&nomid=${nomid}&nomid2=${nomid2}&id2=${idefiscal}`;

    console.log(endpoint);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);

          if (response.data.length > 0) {
            if (parseInt(response.data[0].idcuentacontable) > 0) {
              console.log(
                response.data[0].idcuentacontable,
                response.data[0].idefiscal
              );
            }
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarRegistroPuc = (idpuc) => {
    let campos = "*";
    let nomtab = "puc";
    let nomid = "idpuc";

    let endpoint = `${op.conexion}/api/consulta/modeli?campos=${campos}&id=${idpuc}&nomtab=${nomtab}&nomid=${nomid}`;

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          if (response.data.idpuc > 0) {
            setPuc(response.data);
          }
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setMostrar5(true);
        setActivate(false);
      });
  };

  const seleccionarDetalle = (id) => {
    let nomtab = "requisiciondetalle";
    let nomid = "idrequisicion";

    let endpoint = `${op.conexion}/api/consulta/detalle?nomtab=${nomtab}&nomid=${nomid}&id=${id}`;
    console.log(endpoint);

    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status == 200) {
          console.log(response.data);
          setRecords(response.data);
        }

        setActivate(false);
      })
      .catch(function (error) {
        setTitulo("ERROR");
        setMsg(error.response.data.message);
        setActivate(false);
      });
  };

  const cerrarModalActualizar = () => {
    setMostrar5(false);
  };

  const cerrarMensaje = () => {
    setMostrar(false);

    if (
      msg === "El Clasificador Presupuestario no existe" ||
      "LA CUENTA ES NO CARGABLE"
    ) {
      setMostrar5(true);
    }
  };

  const consultarTipopro = (ope, id) => (event) => {
    event.preventDefault();
    blanquear();

    if (ope === 1) {
      setMostrar5(true);
      setOperacion(1);
    } else if (ope === 4) {
      setOperacion(4);
      seleccionarRegistro(id);
    } else if (ope === 2) {
      setOperacion(2);
      seleccionarRegistro(id);
    } else if (ope === 3) {
      setOperacion(3);
      seleccionarRegistro(id);
    }
  };

  useEffect(() => {
    /*     seleccionarRegistros(); */
    /* seleccionarDeclaWeb(); */
  }, []);

  const cerrar = () => {
    props.setTabla(0)
  };

  const onBotones = (op, per) => (e) => {
    setOperacion(op);
    if (op === 1 || op === 2 || op === 3 || op === 4) {
      if (per.toString() === "1") {
        setVisibleBtn("hidden");
      } else {
        setToast({
          mostrar: true,
          mensaje:
            op === 1
              ? "No posee permiso para Registrar"
              : op === 2
              ? "No posee permiso para Editar"
              : op === 3
              ? "No posee permiso para Eliminar"
              : "No posee permiso para Consultar",
          titulo: "Alerta.",
        });
      }
    } else if (op === 6) {
      setVisibleBtn("visible");
    }
    e.preventDefault();

    if (op === 1) {
      setHabilitado(false);
      setBotones({
        incluir: false,
        consultar: true,
        modificar: true,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: true,
        catalogoBene: false,
      });
    } else if (op === 2) {
      setHabilitado(false);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: false,
        eliminar: true,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
    } else if (op === 3) {
      setHabilitado(true);
      setBotones({
        incluir: true,
        consultar: true,
        modificar: true,
        eliminar: false,
        aceptar: false,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
    } else if (op === 4) {
      setHabilitado(true);
      txtId.current.focus();
      setBotones({
        incluir: true,
        consultar: false,
        modificar: true,
        eliminar: true,
        aceptar: true,
        cancelar: false,
        catalogo: false,
        catalogoBene: true,
      });
    } else if (op === 5) {
    } else if (op === 6) {
      blanquear();
    }
  };

  const seleccionarRegistroTipReten = (id) => {
    setMostrar(false);

    let campos = "*";
    let nomtab = "requisicion";
    let nomid = "idrequisicion";
    let nomid2 = "idefiscal";

    let endpoint = `${op.conexion}/api/consulta/modeli2?campos=${campos}&nomtab=${nomtab}&nomid=${nomid}&id=${id}&nomid2=${nomid2}&id2=${idefiscal}`;

    console.log(endpoint);

    setActivate(true);
    axios
      .get(endpoint, {
        headers: {
          "x-access-token": `${token}`,
          "Content-Type": "application/json",
        },
      })
      .then(function (response) {
        if (response.status === 200) {
          if (response.data !== "") {
            console.log(response.data);
            txtId.current.value = response.data[0].idrequisicion;
            txtConcepto.current.value = response.data[0].concepto;
            txtObservacion.current.value = response.data[0].observaciones;
            seleccionarDetalle(response.data[0].idrequisicion);
            setActivo(false);
          } else {
            setActivo(true);

            setMensaje({
              mostrar: true,
              titulo: "Notificación",
              texto: "No existe un Tipo de Retención con este codigo",
              icono: "informacion",
            });
            txtConcepto.current.value = "";
            txtObservacion.current.value = "";
          }
        }
        setActivate(false);
      })
      .catch(function (error) {
        setActivate(false);
        setMensaje({
          mostrar: true,
          titulo: "Error",
          texto: error.response.data.message,
          icono: "error",
        });
      });
  };

  const validarTipoReten = (event) => {
    event.preventDefault();
    validaSoloNumero(event);
    if (event.which === 13 || typeof event.which === "undefined") {
      if (event.target.value !== "") {
        seleccionarRegistroTipReten(event.target.value);
      } else {
        txtConcepto.current.value = "";
        txtObservacion.current.value = "";
        txtId.current.value = "";
        setActivo(true);
      }
    }
  };

  const gestionarProducto = (op) => (e) => {
    e.preventDefault();
    setOperacionPro(op);
    setMostrar2(true);
  };

  return (
    <div className="col-8 m-0 p-2 d-flex mx-auto mt-5 flex-wrap border rounded">
        <header className="col-12 m-0 px-4 py-2 d-flex justify-content-between azulGradiant rounded-top text-light">
        <h3 className="fw-bold m-0">Gestion de Requisiciones</h3>
        <a onClick={cerrar} type="button" className="text-light fw-bold">
            Salir<i className="fas fa-times ms-2"></i>
        </a>
        </header>
        <div className="col-12 m-0 my-2 p-0 d-flex flex-wrap justify-content-between">
        <div class="col-4 m-0 mb-2 p-0">
            <SearchInput
            label="Código:"
            onKeyUp={validarTipoReten}
            onBlur={validarTipoReten}
            onClickButton={() => setMostrar(true)}
            disabledButton={operacion === 0 ? true : false}
            ref={txtId}
            />
        </div>
        <div class="col-4 m-0 mb-2 p-0">
            <Input
            label="Fecha"
            value={moment.utc(fechaSistema).format("DD-MM-YYYY")}
            ref={txtFecha}
            />
        </div>
        <div class="col-12 m-0 mb-2 p-0">
            <Textarea
            label="Concepto:"
            style={{ height: 70 }}
            ref={txtConcepto}
            />
        </div>
        <div class="col-12 m-0 p-0">
            <Textarea
            label="Observaciones:"
            style={{ height: 70 }}
            ref={txtObservacion}
            />
        </div>
        </div>
        <div className="col-11 m-0 p-0">
        <TblContainer
            container={{
            height: 150,
            width: "100%",
            overflow: "auto",
            padding: "2px",
            }}
        >
            <TblHead />

            <tbody>
            {records &&
                records.map((item, index) => (
                <tr
                    style={{
                    padding: "0",
                    cursor: "pointer",
                    background:
                        itemSelect === index ? "lightskyblue" : "white",
                    }}
                    onClick={seleccionarFila(index)}
                >
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                    >
                    {item.idrequisiciondetalle}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                    >
                    {item.cantidad
                        ? formatMoneda(
                            item.cantidad.toString().replace(".", ","),
                            ",",
                            ".",
                            2
                        )
                        : ""}
                    </td>
                    <td
                    style={{
                        fontSize: "10px",
                        textAlign: "center",
                    }}
                    >
                    {item.descripcion}
                    </td>
                </tr>
                ))}
            </tbody>
        </TblContainer>
        </div>
        <div className="col-1 m-0 p-0 d-flex flex-column align-items-center justify-content-center gap-2">
        <PrimaryButton
            icon="fa-plus m-0"
            onClick={gestionarProducto(1)}
            disabled={activo}
        ></PrimaryButton>
        <InfoButton
            icon="fa-eye m-0"
            onClick={gestionarProducto(4)}
            disabled={activo2}
        ></InfoButton>
        <WarningButton
            icon="fa-edit m-0"
            onClick={gestionarProducto(2)}
            disabled={activo2}
        ></WarningButton>
        <DangerButton
            icon="fa-trash-alt m-0"
            onClick={gestionarProducto(3)}
            disabled={activo2}
        ></DangerButton>
        </div>
        <div
        className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2"
        style={{ visibility: visibleBtn }}
        >
        <PrimaryButton
            icon="fa-plus"
            disabled={botones.incluir}
            onClick={onBotones(1, permiso.toString().substring(1, 2))}
        >
            Incluir
        </PrimaryButton>
        <InfoButton
            icon="fa-eye"
            disabled={botones.consultar}
            onClick={onBotones(4, permiso.toString().substring(0, 1))}
        >
            Consultar
        </InfoButton>
        <WarningButton
            icon="fa-edit"
            disabled={botones.modificar}
            onClick={onBotones(2, permiso.toString().substring(2, 3))}
        >
            Modificar
        </WarningButton>
        <DangerButton
            icon="fa-trash-alt"
            disabled={botones.eliminar}
            onClick={onBotones(3, permiso.toString().substring(3, 4))}
        >
            Eliminar
        </DangerButton>
        </div>
        <div
        className="col-12 m-0 mt-2 p-0 d-flex justify-content-end gap-2"
        style={{
            visibility: visibleBtn === "visible" ? "hidden" : "visible",
        }}
        >
        <SuccessButton
            disabled={botones.aceptar}
            onClick={onBotones(5, "")}
            ref={btnAcepta}
        >
            Aceptar
        </SuccessButton>
        <DangerButton
            disabled={botones.cancelar}
            onClick={onBotones(6, "")}
            ref={btnCancela}
        >
            Cancelar
        </DangerButton>
        </div>
      <ActualizarTipopro
        show={mostrar5}
        declaWeb={declaWeb}
        ip={ip}
        mac={mac}
        idusuario={idusuario}
        tipopro={tipopro}
        puc={puc}
        cuenta={cuenta}
        operacion={operacion}
        onHideRenderizar={seleccionarRegistros}
        onHideCancela={cerrarModalActualizar}
      />
      <AgregarProducto
        show={mostrar2}
        onHideCancelar={() => setMostrar2(false)}
        operacion={operacionPro}
      />

      <Dimmer active={activate} inverted></Dimmer>
      <Mensaje
        titulo={titulo}
        mensaje={msg}
        show={mostrar}
        onHide={cerrarMensaje}
      />
      <CatalogoRequi
        show={mostrar}
        onHideCancelar={() => setMostrar(false)}
        onHideAceptaOrganismo={seleccionarRegistroTipReten}
      />
      <Toasts
        show={toast.mostrar}
        titulo={toast.titulo}
        mensaje={toast.mensaje}
        onHideCancela={cerrarToast}
      />
    </div>
  );
}

export default TablaRequisicion;
